import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const URLV2 = process.env.REACT_APP_API_V2;

const listBoard = 'board/list';
const listMemberBoard = 'board/list-member';
const deleteBoard = 'board/delete';
const createBoard = 'board/create';
const duplicateBoard = 'board/duplicate';
const updateBoard = 'board/update';
const inviteBoard = 'board/invite';
const deleteBoardMember = 'board/delete-member';

export const apiListBoard = async (val) => {
  const datas = await http.post(`${URLV2 + listBoard}`, val);

  return datas.data.data;
};

export const apiListMemberBoard = async (val) => {
  const datas = await http.post(`${URL + listMemberBoard}`, val);

  return datas.data.data;
};

export const apiDeleteBoard = async (val) => {
  const datas = await http.post(`${URL + deleteBoard}`, val);
  return datas.data;
};

export const apiCreateBoard = async (val) => {
  const datas = await http.post(`${URL + createBoard}`, val);

  return datas.data;
};

export const apiUpdateBoard = async (val) => {
  const datas = await http.post(`${URL + updateBoard}`, val);

  return datas.data;
};

export const apiDuplicateBoard = async (val) => {
  const datas = await http.post(`${URL + duplicateBoard}`, val);

  return datas.data;
};
export const apiInviteBoard = async (val) => {
  const datas = await http.post(`${URL + inviteBoard}`, val);

  return datas.data;
};

export const apiDeleteBoardMember = async (val) => {
  const datas = await http.post(`${URL + deleteBoardMember}`, val);

  return datas.data.data;
};
